import $ from 'jquery';
import Region from 'blocks/region/region';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaNoRegion',
			dom: {
				region: '.js-no-region-region'
			},
			classes: {}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$region = this.$el.find(this.options.dom.region);
		return this;
	}


	render() {
		if (this.$el.length) {
			this.getDom();
			this.region = new Region({el: this.$region}).render();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/no-region/no-region.js